import '@vfde-brix/image-caption/dist/styles.css';
import '@vfde-brix/image-caption-list/dist/styles.css';
import { createImageCaptionListComponent } from '@vfde-brix/image-caption-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-image-caption-list', createImageCaptionListComponent, NO_PATTERN_BUSINESS_LOGIC);
